import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-189df3ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex" }

import { IMemberRole } from "@/interfaces/members/IMember";
import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'cellTableRoles',
  props: {
  value: {
    type: Object as PropType<IMemberRole[]>,
    required: true,
  },
  colorRole: { type: String, default: "#212529" },
},
  setup(__props) {

_useCssVars(_ctx => ({
  "ec5008f8": (__props.colorRole)
}))



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.value, (role, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "cell-role tw-text-sm tw-font-medium tw-flex tw-items-center"
      }, [
        _createElementVNode("span", null, _toDisplayString(role.roleName), 1)
      ]))
    }), 128))
  ]))
}
}

})